// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActivePrifle-Container {
  max-width: 1400px;
  margin: 0 auto;
}
.EditBack-profile {
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  padding: 32px 0px 0px 32px;
}
.Edit-profile-Button {
  color: #061522;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 75% */
}
.Active-Profile-Main-Container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  margin: 50px auto 0px auto;
}
.Active-Profile-Main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
  width: 100%;
}

.Active-Profile-Main .EDITGROUP-LOGO-MAIN {
  min-width: 0;
  flex: 1 1 160px;
}

.Active-Profile-Main .EditGroup-Active {
  flex-shrink: 0;
}
.EditAgent-profile {
  color: #405261;
  font-size: 14px;
  margin-top: 2px;

  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.Profile-upload-button {
  border-radius: 8px;
  border-radius: 8px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #fff;
  border: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  width: 128px;
  height: 40px;
  cursor: pointer;
}
.Profile-upload-button.disabled-button {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 11px 22px;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}
.Profile-upload-button:not(:disabled):hover,
.Profile-upload-button:not(:disabled):focus-visible {
  background-color: #0077cc !important;
}

.Edit-profileText {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.Edit-Profile-Section {
  width: 50%;
  margin: 50px auto 0px auto;
}
.profileInformation {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 100% */
}
.profileInformation-setting {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  margin-top: 34px;
  margin-bottom: 20px;
  /* 100% */
  /* width: 50%;
  margin: 0 auto 20px auto; */
}
.Profile-Input-Container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 35px;
  gap: 8px;
  min-width: 0;
  width: 100%;
}

.Profile-Input-Container > * {
  flex: 1 1 220px;
  min-width: 0;
  max-width: 100%;
}
.Profile-Input-Container-Group {
  display: flex;
  flex-direction: column;
  margin-top: 23px;
  gap: 8px;
}
.Profile-Input-Container01 {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  gap: 8px;
  min-width: 0;
  width: 100%;
}

.Profile-Input-Container01 > * {
  flex: 1 1 220px;
  min-width: 0;
  max-width: 100%;
}
.Profile-Line-Bottom {
  margin-top: 56px;
  margin-bottom: 56px;
  width: 100%;
  height: 1px;
  border: 1px solid #e5e9ec;
}
.Profile-Separator {
  border-bottom: 1px solid #e5e9ec;

  margin-left: 24px;
  margin-right: 24px;
  margin-top: 32px;
  margin-bottom: 32px;
  width: auto;
}
.EditProfile-Section {
  width: 50%;
  margin: 0 auto;
}
.General-Sale-Container {
  display: flex;
  gap: 8px;
  height: 40px;
  align-items: center;

  border-radius: 20px;
  border: 1px solid #c5ced6;
  background: #f9fafa;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 3px;
  align-items: center;
}
.GeneralSale-Main-Container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  flex-wrap: wrap;
}
.EditAgent-Container {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.EditAgentStatus {
  display: flex;
  align-items: center;
  border-radius: 8px;
  height: 48px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 4px 15px;
  width: 272px;
}
.EditAgent-Row {
  display: flex;
  gap: 10px; /* Adjust spacing between items */
  margin-bottom: 10px; /* Space between rows */
}

.EditAgent-Row .EditAgentStatus {
  flex: 1; /* Make items take equal width in the row */
}

.ProfileInformation-container {
  width: 50%;
  margin: 0 auto;
}

.EditAgentActive {
  border-radius: 8px;
  border: 1px solid #148dfd;
  background: #f3fbff;
  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);
}
.Avaliablity-Container {
  margin-top: 34px;
}
.Avaliable-Main-Container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
}
.Aavaliable-Main-Container001 {
  margin: 0 auto;

  padding: 24px 0px 24px 24px;

  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
}
/* @media screen and (max-width: 1430px) {
  .Aavaliable-Main-Container001 {
    width: 65%;
  }
} */

.Avaliable-button {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 16px;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.Avaliable-Checkbox-main {
  display: flex;
  margin-top: 4px;
  gap: 8px;
}

.Avaliable-button-container {
  display: flex;
  gap: 8px;
  align-items: center;
}
.RoleAgent-Container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.RoleAgentStatus {
  display: flex; /* horizontal layout */
  align-items: center; /* vertically center content */
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 23px; /* horizontal padding */
  height: 80px;
  width: 100%;
  box-sizing: border-box;
}

.RoleAgentStatus .MuiFormControlLabel-root {
  margin-right: 15px; /* space between radio and text */
}

.RoleAgentStatus .role-text-container {
  display: flex;
  flex-direction: column;
}

.RoleAgentStatus .role-name {
  font-weight: 500;
  font-size: 16px;
  color: #1a1a1a;
}

.RoleAgentStatus .role-description {
  font-size: 14px;
  color: #556575;
}

.RoleAgentActive {
  border-color: #2a9df4; /* highlight selected role */
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.Addworking-button-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  /* width: 50%;
  margin-inline: auto;
  margin-top: 24px; */
}
.addworking-reset {
  width: 128px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  cursor: pointer;
}
.addworking-reset:not(:disabled):hover {
  border-color: #c5ced6 !important;
  outline: none;
}
.addworking-save {
  border-radius: 8px;
  border: none;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  width: 128px;
  height: 40px;
  flex-shrink: 0;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  cursor: pointer;
}
.addworking-save:not(:disabled):hover {
  background: #0077cc !important;
}
.RoleAgentActive {
  border-radius: 8px;
  border: 1px solid #148dfd;
  background: #f3fbff;
  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);
}
.EditProfileEmail-Main-Container {
  margin-top: 20px;
}
.EditProfileEmail-Container {
  display: flex;
  gap: 8px;
  padding: 7px;
  padding-top: 12px;
}

.Suspend-agent-container {
  margin-top: 20px;
}
.suspentagent-text {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}
.Suspend-agent-button {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff !important;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05) !important;
  color: #405261 !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  padding: 11px 30px;
  margin-top: 20px;
  cursor: pointer;
}

.Suspend-agent-button:not(:disabled):hover {
  border-color: #c5ced6 !important;
  outline: none;
}

.Suspend-delete-button {
  border-radius: 8px;
  background: #ff4d4f;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #fff;
  border: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  padding: 11px 30px;
  margin-top: 40px;
  cursor: pointer;
}

.Input-headingcontainer-edit {
}
.input-new-edit {
  width: 100%;
  flex-shrink: 0;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 13px 16px 13px 16px; /* Adjusted padding to accommodate the SVG */
  outline: none;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.input-container-edit {
  position: relative;
  width: 100%;
}

.svg-containerTop {
  position: absolute;
  top: 25%;
  right: 0px;
  width: 18px;
  transform: translateY(-50%);
  color: #777;
  cursor: pointer;
}

.svg-containerDown {
  position: absolute;
  top: 65%;
  right: 0px;
  width: 18px;
  transform: translateY(-50%);

  color: #777;
  cursor: pointer;
}
.Item-general-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff4d4f;
  border-radius: 20px;
  width: 34px;
  height: 34px;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.item-general-close {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  margin-right: 12px;
}
.spaced {
  margin-right: 8px;
  font-family: "Inter";
  font-weight: 500;
  color: #405261;
  font-size: 14px;
  line-height: 12px;
}

.notifications-main-container {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto 0 0;
  background: white;
  padding: 0; /* No padding until large screen */
  box-sizing: border-box;
}

/* 🖥️ Add padding ONLY on very large screens */
@media (min-width: 1441px) {
  .notifications-main-container {
    /* padding-left: 80px; */
    margin-left: 0;
    padding-right: 100px;
  }
}
.profile-main-container {
  /* width: 100%; */
  max-width: 1440px;
  margin: 0 auto 0 0;
  background: white;
  padding: 0; /* No padding until large screen */
  box-sizing: border-box;
}

/* Account & Profile — responsive two-column (sidebar + content), zoom-safe */
.profile-settings-layout-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  gap: 24px;
  padding: 24px;
  padding-top: 40px;
  align-items: stretch;
}

@media (min-width: 900px) {
  .profile-settings-layout-row {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding-right: 24px;
    padding-top: 40px;
  }
}

@media (min-width: 1200px) {
  .profile-settings-layout-row {
    padding-right: 40px;
  }
}

@media (min-width: 1440px) {
  .profile-settings-layout-row {
    padding-right: 80px;
  }
}

.profile-settings-layout-sidebar {
  width: 100%;
  max-width: 329px;
  min-width: 0;
}

@media (min-width: 900px) {
  .profile-settings-layout-sidebar {
    flex-shrink: 0;
    width: 329px;
    max-width: 329px;
  }
}

.profile-settings-layout-sidebar--spacer {
  display: none;
  margin: 0;
  padding: 0;
}

@media (min-width: 900px) {
  .profile-settings-layout-sidebar--spacer {
    display: block;
    flex-shrink: 0;
    width: 329px;
    max-width: 329px;
    min-height: 1px;
  }
}

.profile-settings-layout-content {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  max-width: 552px;
  box-sizing: border-box;
}

@media (min-width: 900px) {
  .profile-settings-layout-content {
    flex: 1 1 0;
  }
}

/* 🖥️ Add padding ONLY on very large screens */
@media (min-width: 1441px) {
  .profile-main-container {
    /* padding-left: 80px; */
    margin-left: 0;
    padding-right: 100px;
  }
}
@media (min-width: 1550px) {
  .profile-main-container {
    margin-left: 0;
    padding-right: 200px;
  }
}
@media (min-width: 1600px) {
  .profile-main-container {
    margin-left: 0;
    padding-right: 150px;
  }
}
@media (min-width: 1700px) {
  .profile-main-container {
    margin-left: 0;
    padding-right: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/TeamComponents/TeamEditProfile/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,QAAQ;AAC7B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;;EAEf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT;6BAC2B;AAC7B;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gCAAgC;;EAEhC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;;EAEnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS,EAAE,iCAAiC;EAC5C,mBAAmB,EAAE,uBAAuB;AAC9C;;AAEA;EACE,OAAO,EAAE,2CAA2C;AACtD;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mDAAmD;AACrD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;;EAEd,2BAA2B;;EAE3B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;;;GAIG;;AAEH;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa,EAAE,sBAAsB;EACrC,mBAAmB,EAAE,8BAA8B;EACnD,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa,EAAE,uBAAuB;EACtC,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB,EAAE,iCAAiC;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB,EAAE,4BAA4B;EACnD,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR;;qBAEmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mDAAmD;AACrD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,4DAA4D;EAC5D,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;AACA;AACA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,4BAA4B,EAAE,4CAA4C;EAC1E,aAAa;AACf;AACA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,2BAA2B;;EAE3B,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;EAEf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU,EAAE,kCAAkC;EAC9C,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE;IACE,wBAAwB;IACxB,cAAc;IACd,oBAAoB;EACtB;AACF;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU,EAAE,kCAAkC;EAC9C,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,cAAc;IACd,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,wBAAwB;IACxB,cAAc;IACd,oBAAoB;EACtB;AACF;AACA;EACE;IACE,cAAc;IACd,oBAAoB;EACtB;AACF;AACA;EACE;IACE,cAAc;IACd,oBAAoB;EACtB;AACF;AACA;EACE;IACE,cAAc;IACd,oBAAoB;EACtB;AACF","sourcesContent":[".ActivePrifle-Container {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n.EditBack-profile {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  cursor: pointer;\n  padding: 32px 0px 0px 32px;\n}\n.Edit-profile-Button {\n  color: #061522;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 75% */\n}\n.Active-Profile-Main-Container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 50%;\n  margin: 50px auto 0px auto;\n}\n.Active-Profile-Main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  min-width: 0;\n  width: 100%;\n}\n\n.Active-Profile-Main .EDITGROUP-LOGO-MAIN {\n  min-width: 0;\n  flex: 1 1 160px;\n}\n\n.Active-Profile-Main .EditGroup-Active {\n  flex-shrink: 0;\n}\n.EditAgent-profile {\n  color: #405261;\n  font-size: 14px;\n  margin-top: 2px;\n\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.Profile-upload-button {\n  border-radius: 8px;\n  border-radius: 8px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #fff;\n  border: none;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  width: 128px;\n  height: 40px;\n  cursor: pointer;\n}\n.Profile-upload-button.disabled-button {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 11px 22px;\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n}\n.Profile-upload-button:not(:disabled):hover,\n.Profile-upload-button:not(:disabled):focus-visible {\n  background-color: #0077cc !important;\n}\n\n.Edit-profileText {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.Edit-Profile-Section {\n  width: 50%;\n  margin: 50px auto 0px auto;\n}\n.profileInformation {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 100% */\n}\n.profileInformation-setting {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  margin-top: 34px;\n  margin-bottom: 20px;\n  /* 100% */\n  /* width: 50%;\n  margin: 0 auto 20px auto; */\n}\n.Profile-Input-Container {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 35px;\n  gap: 8px;\n  min-width: 0;\n  width: 100%;\n}\n\n.Profile-Input-Container > * {\n  flex: 1 1 220px;\n  min-width: 0;\n  max-width: 100%;\n}\n.Profile-Input-Container-Group {\n  display: flex;\n  flex-direction: column;\n  margin-top: 23px;\n  gap: 8px;\n}\n.Profile-Input-Container01 {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 20px;\n  gap: 8px;\n  min-width: 0;\n  width: 100%;\n}\n\n.Profile-Input-Container01 > * {\n  flex: 1 1 220px;\n  min-width: 0;\n  max-width: 100%;\n}\n.Profile-Line-Bottom {\n  margin-top: 56px;\n  margin-bottom: 56px;\n  width: 100%;\n  height: 1px;\n  border: 1px solid #e5e9ec;\n}\n.Profile-Separator {\n  border-bottom: 1px solid #e5e9ec;\n\n  margin-left: 24px;\n  margin-right: 24px;\n  margin-top: 32px;\n  margin-bottom: 32px;\n  width: auto;\n}\n.EditProfile-Section {\n  width: 50%;\n  margin: 0 auto;\n}\n.General-Sale-Container {\n  display: flex;\n  gap: 8px;\n  height: 40px;\n  align-items: center;\n\n  border-radius: 20px;\n  border: 1px solid #c5ced6;\n  background: #f9fafa;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 3px;\n  align-items: center;\n}\n.GeneralSale-Main-Container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 16px;\n  flex-wrap: wrap;\n}\n.EditAgent-Container {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.EditAgentStatus {\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  height: 48px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 4px 15px;\n  width: 272px;\n}\n.EditAgent-Row {\n  display: flex;\n  gap: 10px; /* Adjust spacing between items */\n  margin-bottom: 10px; /* Space between rows */\n}\n\n.EditAgent-Row .EditAgentStatus {\n  flex: 1; /* Make items take equal width in the row */\n}\n\n.ProfileInformation-container {\n  width: 50%;\n  margin: 0 auto;\n}\n\n.EditAgentActive {\n  border-radius: 8px;\n  border: 1px solid #148dfd;\n  background: #f3fbff;\n  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);\n}\n.Avaliablity-Container {\n  margin-top: 34px;\n}\n.Avaliable-Main-Container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px;\n}\n.Aavaliable-Main-Container001 {\n  margin: 0 auto;\n\n  padding: 24px 0px 24px 24px;\n\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n}\n/* @media screen and (max-width: 1430px) {\n  .Aavaliable-Main-Container001 {\n    width: 65%;\n  }\n} */\n\n.Avaliable-button {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 16px;\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.Avaliable-Checkbox-main {\n  display: flex;\n  margin-top: 4px;\n  gap: 8px;\n}\n\n.Avaliable-button-container {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n.RoleAgent-Container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.RoleAgentStatus {\n  display: flex; /* horizontal layout */\n  align-items: center; /* vertically center content */\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 23px; /* horizontal padding */\n  height: 80px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.RoleAgentStatus .MuiFormControlLabel-root {\n  margin-right: 15px; /* space between radio and text */\n}\n\n.RoleAgentStatus .role-text-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.RoleAgentStatus .role-name {\n  font-weight: 500;\n  font-size: 16px;\n  color: #1a1a1a;\n}\n\n.RoleAgentStatus .role-description {\n  font-size: 14px;\n  color: #556575;\n}\n\n.RoleAgentActive {\n  border-color: #2a9df4; /* highlight selected role */\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.Addworking-button-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  /* width: 50%;\n  margin-inline: auto;\n  margin-top: 24px; */\n}\n.addworking-reset {\n  width: 128px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  cursor: pointer;\n}\n.addworking-reset:not(:disabled):hover {\n  border-color: #c5ced6 !important;\n  outline: none;\n}\n.addworking-save {\n  border-radius: 8px;\n  border: none;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  width: 128px;\n  height: 40px;\n  flex-shrink: 0;\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  cursor: pointer;\n}\n.addworking-save:not(:disabled):hover {\n  background: #0077cc !important;\n}\n.RoleAgentActive {\n  border-radius: 8px;\n  border: 1px solid #148dfd;\n  background: #f3fbff;\n  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);\n}\n.EditProfileEmail-Main-Container {\n  margin-top: 20px;\n}\n.EditProfileEmail-Container {\n  display: flex;\n  gap: 8px;\n  padding: 7px;\n  padding-top: 12px;\n}\n\n.Suspend-agent-container {\n  margin-top: 20px;\n}\n.suspentagent-text {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n}\n.Suspend-agent-button {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff !important;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05) !important;\n  color: #405261 !important;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  padding: 11px 30px;\n  margin-top: 20px;\n  cursor: pointer;\n}\n\n.Suspend-agent-button:not(:disabled):hover {\n  border-color: #c5ced6 !important;\n  outline: none;\n}\n\n.Suspend-delete-button {\n  border-radius: 8px;\n  background: #ff4d4f;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #fff;\n  border: none;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  padding: 11px 30px;\n  margin-top: 40px;\n  cursor: pointer;\n}\n\n.Input-headingcontainer-edit {\n}\n.input-new-edit {\n  width: 100%;\n  flex-shrink: 0;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 13px 16px 13px 16px; /* Adjusted padding to accommodate the SVG */\n  outline: none;\n}\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n}\n\n.input-container-edit {\n  position: relative;\n  width: 100%;\n}\n\n.svg-containerTop {\n  position: absolute;\n  top: 25%;\n  right: 0px;\n  width: 18px;\n  transform: translateY(-50%);\n  color: #777;\n  cursor: pointer;\n}\n\n.svg-containerDown {\n  position: absolute;\n  top: 65%;\n  right: 0px;\n  width: 18px;\n  transform: translateY(-50%);\n\n  color: #777;\n  cursor: pointer;\n}\n.Item-general-logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #ff4d4f;\n  border-radius: 20px;\n  width: 34px;\n  height: 34px;\n  color: #fff;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.item-general-close {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n\n  margin-right: 12px;\n}\n.spaced {\n  margin-right: 8px;\n  font-family: \"Inter\";\n  font-weight: 500;\n  color: #405261;\n  font-size: 14px;\n  line-height: 12px;\n}\n\n.notifications-main-container {\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto 0 0;\n  background: white;\n  padding: 0; /* No padding until large screen */\n  box-sizing: border-box;\n}\n\n/* 🖥️ Add padding ONLY on very large screens */\n@media (min-width: 1441px) {\n  .notifications-main-container {\n    /* padding-left: 80px; */\n    margin-left: 0;\n    padding-right: 100px;\n  }\n}\n.profile-main-container {\n  /* width: 100%; */\n  max-width: 1440px;\n  margin: 0 auto 0 0;\n  background: white;\n  padding: 0; /* No padding until large screen */\n  box-sizing: border-box;\n}\n\n/* Account & Profile — responsive two-column (sidebar + content), zoom-safe */\n.profile-settings-layout-row {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  gap: 24px;\n  padding: 24px;\n  padding-top: 40px;\n  align-items: stretch;\n}\n\n@media (min-width: 900px) {\n  .profile-settings-layout-row {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    padding-right: 24px;\n    padding-top: 40px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .profile-settings-layout-row {\n    padding-right: 40px;\n  }\n}\n\n@media (min-width: 1440px) {\n  .profile-settings-layout-row {\n    padding-right: 80px;\n  }\n}\n\n.profile-settings-layout-sidebar {\n  width: 100%;\n  max-width: 329px;\n  min-width: 0;\n}\n\n@media (min-width: 900px) {\n  .profile-settings-layout-sidebar {\n    flex-shrink: 0;\n    width: 329px;\n    max-width: 329px;\n  }\n}\n\n.profile-settings-layout-sidebar--spacer {\n  display: none;\n  margin: 0;\n  padding: 0;\n}\n\n@media (min-width: 900px) {\n  .profile-settings-layout-sidebar--spacer {\n    display: block;\n    flex-shrink: 0;\n    width: 329px;\n    max-width: 329px;\n    min-height: 1px;\n  }\n}\n\n.profile-settings-layout-content {\n  flex: 1 1 auto;\n  width: 100%;\n  min-width: 0;\n  max-width: 552px;\n  box-sizing: border-box;\n}\n\n@media (min-width: 900px) {\n  .profile-settings-layout-content {\n    flex: 1 1 0;\n  }\n}\n\n/* 🖥️ Add padding ONLY on very large screens */\n@media (min-width: 1441px) {\n  .profile-main-container {\n    /* padding-left: 80px; */\n    margin-left: 0;\n    padding-right: 100px;\n  }\n}\n@media (min-width: 1550px) {\n  .profile-main-container {\n    margin-left: 0;\n    padding-right: 200px;\n  }\n}\n@media (min-width: 1600px) {\n  .profile-main-container {\n    margin-left: 0;\n    padding-right: 150px;\n  }\n}\n@media (min-width: 1700px) {\n  .profile-main-container {\n    margin-left: 0;\n    padding-right: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
